import cleanedFilename from '~/util/cleanedFilename';

export default {
  CLOSE_BUTTON: `${cleanedFilename(__filename)}-close-button`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
